import apolloClient from 'api/apolloClient';
import { DOMAIN_PRODUCT_LINES } from 'api/domainService';
import { DomainProductLine, InputFilter } from 'types/domainService';

export async function getDomainProductLineCached(inputFilter: InputFilter): Promise<DomainProductLine[]> {
  return (
    await apolloClient.query<{ getProductLines: DomainProductLine[] }>({
      query: DOMAIN_PRODUCT_LINES,
      variables: { inputFilter },
      fetchPolicy: 'cache-first',
    })
  ).data.getProductLines;
}
